import { Input, Label } from './Checkbox.styles';
import type { CheckboxProps } from './Checkbox.types';

export function Checkbox({
  checked,
  onChange,
  label,
  disabled,
  'aria-label': ariaLabel,
}: CheckboxProps) {
  return (
    <Label data-disabled={disabled}>
      <Input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      {label}
    </Label>
  );
}
